import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisclosureComponent } from './disclosure.component';
import { SharedModule } from '../../shared/shared.module';
import { PrimeNGModule } from '../../shared/prime-ng.module';



@NgModule({
  declarations: [ DisclosureComponent],
  imports: [
    CommonModule,
    SharedModule,
    PrimeNGModule
  ],
  exports: [
    DisclosureComponent
  ]
})
export class DisclosureModule { }
